import { timeout } from "@/utils/util.js";
import { throttle } from "@/utils/throttle.js";
window.continueScroll = true;
//  列表中定位当前图片
const locate_current_picture = async (el) => {
  await timeout(80);
  let scrollY = 0;
  let winScrllTop = $(window).scrollTop();
  let winHeight = window.innerHeight;
  let itemOffsetTop = $(el).offset().top;
  let itemHeight = $(el).outerHeight();
  let scrollTo = itemOffsetTop - winHeight / 3;

  // 情况1：图片在顶部，未显示全
  if (itemOffsetTop < winScrllTop) {
    scrollY = itemOffsetTop - 74;
    window.scrollTo(0, scrollY);
    //  情况2：图片在底部，未显示全
  } else if (
    itemOffsetTop > winScrllTop &&
    itemOffsetTop + itemHeight > winScrllTop + winHeight
  ) {
    scrollY =
      winScrllTop +
      (itemOffsetTop + itemHeight - (winScrllTop + winHeight)) +
      10;
    window.scrollTo(0, scrollY);
  }
};

var scrollTop, windowHeight, scrollHeight;
//  图片滚动加载
const scroll_schema = throttle(
  () => {
    let update = () => {
      //  距离顶部的距离
      scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //  windo可视区的高度
      windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //  滚动条的总高度
      scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //  滚动条到底部的条件
      if (
        scrollTop + windowHeight >= scrollHeight - 400 &&
        windowHeight < scrollHeight
      ) {
        window.continueScroll && window.scroll_Fn();
        window.continueScroll = false;
      }
    };
    update();
  },
  200,
  false
);

export { locate_current_picture, scroll_schema };
